import { useState } from "react";
import { Eye, EyeOff, Loader2 } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function WatchlistButton({ product, className = "" }) {
  const [added, setAdded] = useState(false);
  const [loading, setLoading] = useState(false);
  const { email } = useAuth();

  const handleAdd = async () => {
    if (added) return;
    setLoading(true);
    try {
      const payload = {
        product_name: product.product_name || product.title || product.name || "",
        search_query: product.search_query || product.product_name || product.title || "",
        product_image: product.product_image || product.image || "",
        buy_platform: product.buy_platform || product.seller || "",
        buy_price: product.buy_price || product.price || 0,
        sell_platform: product.sell_platform || "",
        sell_price: product.sell_price || 0,
        margin: product.margin || 0,
        margin_percent: product.margin_percent || 0,
        buy_url: product.buy_url || product.url || "",
        sell_url: product.sell_url || "",
        user_email: email || "",
      };
      const res = await axios.post(`${API}/watchlist`, payload);
      setAdded(true);
      if (res.data.status === "exists") {
        toast.info("Deja dans la watchlist");
      } else {
        toast.success("Ajoute a la watchlist !");
      }
    } catch (error) {
      toast.error("Erreur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleAdd}
      disabled={loading || added}
      className={`inline-flex items-center gap-1 text-xs ${
        added
          ? "neo-button-primary"
          : "neo-button-secondary"
      } ${className}`}
      data-testid="watchlist-btn"
    >
      {loading ? (
        <Loader2 size={12} className="animate-spin" />
      ) : added ? (
        <EyeOff size={12} />
      ) : (
        <Eye size={12} />
      )}
      {added ? "Suivi" : "Suivre"}
    </button>
  );
}
